import service from "@/router/request";
import { setToken } from '@/utils/token-util';

/**
 * 登录
 */
export async function login(data) {
    data.tenantId = 1; // 租户id
    const res = await service.post('/login', data);
    if (res.data.code === 0) {
        setToken(res.data.data.access_token, true);
        return res.data.message;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 获取验证码
 * @param params 查询条件
 */
export async function getSmsCode(params) {
    const res = await service.get('mobile/sendLoginSmsCode', {
        params
    });
    if (res.data.code === 0) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}

// /**
//  * 分页查询分类
//  * @param params 查询条件
//  */
// export async function pageClassifys(params) {
//     const res = await request.get('/business/classify/page', {
//         params
//     });
//     if (res.data.code === 0) {
//         return res.data.data;
//     }
//     return Promise.reject(new Error(res.data.message));
// }

// /**
//  * 查询分类列表
//  * @param params 查询条件
//  */
// export async function listClassifys(params) {
//     const res = await request.get('/business/classify', {
//         params
//     });
//     if (res.data.code === 0 && res.data.data) {
//         return res.data.data;
//     }
//     return Promise.reject(new Error(res.data.message));
// }

// /**
//  * 根据id查询分类
//  * @param id 分类id
//  */
// export async function getClassify(id) {
//     const res = await request.get('/business/classify/' + id);
//     if (res.data.code === 0) {
//         return res.data.data;
//     }
//     return Promise.reject(new Error(res.data.message));
// }

// /**
//  * 添加分类
//  * @param data 分类信息
//  */
// export async function addClassify(data) {
//     const res = await request.post('/business/classify', data);
//     if (res.data.code === 0) {
//         return res.data.message;
//     }
//     return Promise.reject(new Error(res.data.message));
// }

// /**
//  * 修改分类
//  * @param data 分类信息
//  */
// export async function updateClassify(data) {
//     const res = await request.put('/business/classify', data);
//     if (res.data.code === 0) {
//         return res.data.message;
//     }
//     return Promise.reject(new Error(res.data.message));
// }

// /**
//  * 删除分类
//  * @param id 分类id
//  */
// export async function removeClassify(id) {
//     const res = await request.delete('/business/classify/' + id);
//     if (res.data.code === 0) {
//         return res.data.message;
//     }
//     return Promise.reject(new Error(res.data.message));
// }

// /**
//  * 批量删除分类
//  * @param data 分类id集合
//  */
// export async function removeClassifys(data) {
//     const res = await request.delete('/business/classify/batch', {
//         data
//     });
//     if (res.data.code === 0) {
//         return res.data.message;
//     }
//     return Promise.reject(new Error(res.data.message));
// }

// /** 2024.1.22
//  * 根据id查询分类名称
//  * @param id 分类id
//  */
// export async function getClassifyName(id) {
//     const res = await request.get('/business/customerTags/list?classifyId=' + id);
//     if (res.data.code === 0) {
//         return res.data.data;
//     }
//     return Promise.reject(new Error(res.data.message));
// }
